export { default as EmployeRights } from './page';


// WEBPACK FOOTER //
// ./src/pages/employeRights/index.js